<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="pii"></a><a class="page" id="piii"></a>THE STRUCTURE OF PRODUCTION</h1>
<h1 class="bk1">New Revised Edition</h1>
<p class="bkau">MARK SKOUSEN</p>
<p class="bkpub"><img alt="" height="44" src="images/NYU_TitlePage_Logo.jpg" width="35"/></p>
<p class="bkpub1">NEW YORK UNIVERSITY PRESS</p>
<p class="bkpub1">NEW YORK &amp; LONDON</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nyu-skousen-0003.vue?696e19dc